import React from 'react'

import styled from '@emotion/styled'
import { Dropdown, IconButton } from 'shared/ui'

const IconWithTooltip = React.memo(() => {
  return (
    <IconButton
      name="sortDown"
      size="small"
      tooltip="Sorting"
      iconSize={18}
      svg
    />
  )
})

class SortMenu extends React.PureComponent {
  state = { isOpen: false }

  open = () => {
    this.setState({ isOpen: true })
  }

  close = () => {
    this.setState({ isOpen: false })
  }

  render() {
    const { className, options } = this.props

    const { isOpen } = this.state
    const trigger = <IconWithTooltip />
    if (!isOpen) {
      return (
        <div className={className} onClick={this.open}>
          {trigger}
        </div>
      )
    }
    return (
      <Dropdown
        className={className}
        direction="left"
        header="Sorting"
        open
        onClose={this.close}
        icon={null}
        options={options}
        trigger={trigger}
      />
    )
  }
}

SortMenu.displayName = 'SortMenu'

const Styled = styled(SortMenu)`
  &&& {
    &.active > .Icon-swap-vert {
      color: ${props => props.theme.color.primary.brand};
    }

    .Icon-swap-vert {
      color: ${props => props.theme.color.monochrome.medium};
      font-size: 16px;
    }
    .Icon-swap-vert:hover {
      color: ${props => props.theme.color.primary.brand};
    }
  }
`

export default Styled
